var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { class: _vm.getClassName("modal") }, [
        _c("div", {
          class: _vm.getClassName("modal__overlay"),
          on: { click: _vm.hideModal }
        }),
        _vm._v(" "),
        _c("div", { class: _vm.getClassName("modal__wrapper") }, [
          _c(
            "button",
            {
              staticClass: "modal__close--upper",
              attrs: { type: "button" },
              on: { click: _vm.hideModal }
            },
            [_c("span", { staticClass: "modal__cross--white" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.getClassName("modal__content") },
            [
              _vm.content
                ? _c("v-img", {
                    class: _vm.getClassName("modal__image"),
                    attrs: { src: _vm.content, alt: "" }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.media
                ? _c(
                    "button",
                    {
                      staticClass: "modal__close",
                      attrs: { type: "button" },
                      on: { click: _vm.hideModal }
                    },
                    [
                      _c("span", { staticClass: "modal__cross" }),
                      _vm._v("\n        閉じる\n      ")
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }